import type { CompanyDocumentView, CompanyKnowledgeDocument } from "./types";

export function toCompanyKnowledgeDocument(
  document: CompanyDocumentView
): CompanyKnowledgeDocument {
  const uploadedAt = document.fileUploadedAt ?? document.createdAt;

  return {
    id: document.companyDocumentId,
    name: document.name,
    description: document.description ?? "",
    contentType: document.contentType,
    uploadedAt,
    fileSizeBytes: document.fileSizeBytes,
    useInAva: document.useInAva,
    fileName: document.filename,
    renewed: Boolean(document.fileUploadedAt) && document.fileUploadedAt !== document.createdAt,
  };
}
